import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import demoService from '../../services/demoService';

const spin = keyframes`to { transform: rotate(360deg); }`;

const Wrap = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: linear-gradient(135deg, #0d0f14 0%, #12141a 50%, #0d0f14 100%);
  color: #e5e7eb;
  font-family: 'Inter', system-ui, sans-serif;
  text-align: center;
  padding: 24px;

  .logo { font-size: 1.6rem; font-weight: 800; letter-spacing: -0.5px; }
  .logo span { color: #10b981; }
  .spinner {
    width: 42px; height: 42px; border-radius: 50%;
    border: 3px solid rgba(16,185,129,0.2); border-top-color: #10b981;
    animation: ${spin} 0.8s linear infinite;
  }
  .msg { color: rgba(255,255,255,0.55); font-size: 0.95rem; max-width: 420px; }
  .error { color: #ef4444; }
  button {
    margin-top: 8px; padding: 10px 20px; border-radius: 10px; border: none;
    background: #10b981; color: #06281d; font-weight: 600; cursor: pointer;
  }
`;

export default function DemoEntry() {
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await demoService.enterDemo();
        if (!cancelled) window.location.replace('/');
      } catch (e) {
        console.error('Erro ao iniciar demo:', e);
        if (!cancelled) setError('Não foi possível iniciar a demonstração. Tente novamente.');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Wrap>
      <div className="logo">Vi<span>dal</span></div>
      {error ? (
        <>
          <p className="msg error">{error}</p>
          <button onClick={() => window.location.reload()}>Tentar novamente</button>
        </>
      ) : (
        <>
          <div className="spinner" />
          <p className="msg">Preparando sua conta de demonstração com dados de exemplo...</p>
        </>
      )}
    </Wrap>
  );
}
